import React, { useMemo, memo } from 'react';
import css from './LinkPreviewComponent.module.css';

const LinkPreviewComponent = ({ url = '' }) => {
  const ensureProtocol = inputUrl =>
    /^https?:\/\//i.test(inputUrl) ? inputUrl : `https://${inputUrl}`;

  const isYouTubeUrl = inputUrl =>
    /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(inputUrl);

  const extractYouTubeVideoId = inputUrl => {
    const shortMatch = inputUrl.match(/^https?:\/\/youtu\.be\/([a-zA-Z0-9_-]+)/);
    const longMatch = inputUrl.match(/[?&]v=([a-zA-Z0-9_-]+)/);
    return shortMatch?.[1] || longMatch?.[1] || null;
  };

  const preview = useMemo(() => {
    if (!url) return null;

    const formattedUrl = ensureProtocol(url);

    let hostname = formattedUrl;

    try {
      hostname = new URL(formattedUrl).hostname.replace('www.', '');
    } catch (e) {
      hostname = formattedUrl;
    }

    return {
      formattedUrl,
      hostname,
      youTubeVideoId: extractYouTubeVideoId(formattedUrl),
      isYouTube: isYouTubeUrl(formattedUrl),
    };
  }, [url]);

  if (!preview) return null;

  if (preview.isYouTube && preview.youTubeVideoId) {
    return (
      <div className={css.linkWarpper}>
        <div className={css.youtubeEmbed}>
          <iframe
            width="100%"
            height="300"
            src={`https://www.youtube.com/embed/${preview.youTubeVideoId}`}
            title="YouTube video player"
            frameBorder="0"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  return (
    <div className={css.linkWarpper}>
      <a
        className={css.innerWrapper}
        href={preview.formattedUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        <div>
          <div className={css.title}>{preview.hostname}</div>
          <div className={css.description}>
            Open this link in a new tab
          </div>
          <div className={css.link}>{preview.formattedUrl}</div>
        </div>
      </a>
    </div>
  );
};

export default memo(LinkPreviewComponent);
